<template>
    <div class="nav mt-0 ">
        <router-link :to="{ name: pageViews.KAFKACONFIGGENERATORVIEW }" class="link" >Kafka Config</router-link>
        <router-link :to="{ name: pageViews.SCHEMACONVERTERVIEW }" class="link" >Schema➜Avro</router-link>
        <router-link :to="{ name: pageViews.CONVERTERVIEW }" class="link" >XSLT Files</router-link>
        <router-link :to="{ name: pageViews.CONNECTOR_CONFIG_GENERATOR_VIEW }" class="link" >Connector Config</router-link>
        <router-link :to="{ name: pageViews.MAPPERVIEW }" class="link" >Mapping Documents</router-link>
        <router-link :to="{ name: pageViews.APIVIEW }" class="link" >API Code</router-link>        
        <!-- <router-link :to="{ name: pageViews.ORCHESTRATION_VIEW }" class="link" >Orchestrations</router-link> -->
    </div>
</template>

<script>
import { pageViews, app_mode } from "../../utils/util";

    export default {
        name: pageViews.INDEPENDENT_ACC_VIEW,
        data() {
            return {
                pageViews: Object.freeze(pageViews),
            }
        },
        
    }
    

</script>

<style scoped>
.nav {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: var(--surface);
  border-bottom: 1px solid var(--border-color);
  padding: 8px 12px;
  gap: 12px;
  transition: background 0.3s ease, border-color 0.3s ease;
}

/* Each nav item */
.link {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  text-decoration: none;
  border-radius: 10px;
  position: relative;
  transition: all 0.25s ease;
  background: var(--surface-hover);
}

/* optional: add separator between tabs */
.link + .link {
  border-left: 1px solid var(--border-color);
  padding-left: 16px;
}

/* Hover effect: soft lift */
.link:hover {
  background: var(--surface-hover);
  color: var(--text-primary);
}

/* Active route highlight */
.link.router-link-active {
  background: var(--surface);
  color: var(--text-primary);
  font-weight: 600;
  box-shadow: 0 0 0 1px var(--border-color);
  border-radius: 12px;
  position: relative;
  transition: all 0.25s ease, box-shadow 0.25s ease;
}

/* Active tab subtle border around */
.link.router-link-active::before {
  content: "";
  position: absolute;
  inset: 0;
  border: 2px solid var(--primary);
  border-radius: 12px;
  pointer-events: none;
}

/* Icon color transitions */
.link.router-link-active img,
.link:hover img {
  filter: brightness(0) saturate(100%) invert(36%) sepia(91%) saturate(2478%)
    hue-rotate(220deg) brightness(105%) contrast(98%);
  transition: filter 0.3s ease;
}

/* === Dark Mode Fine-Tuning === */
[data-theme="dark"] .nav {
  background: var(--surface);
  border-color: var(--border-color);
}

[data-theme="dark"] .link {
  color: var(--text-secondary);
}

[data-theme="dark"] .link:hover {
  background: var(--surface-hover);
  color: var(--text-primary);
}

[data-theme="dark"] .link.router-link-active {
  background: var(--surface-active);
  color: var(--text-primary);
  box-shadow: 0 0 0 1px var(--primary);
}

[data-theme="dark"] .link.router-link-active::before {
  border-color: var(--primary);
}


/* Optional subtle animation */
.link.router-link-active {
  transition: all 0.25s ease, box-shadow 0.25s ease;
}

</style>